<rask-vertical-collapsable direction="both"
    leftSideCloseText="Dölj formulär"
    leftSideOpenText="Visa formulär"
    rightSideCloseText="Dölj karta"
    rightSideOpenText="Visa karta"
    [showFlap]="true"
    [showBar]="false"
    class="kontrakt-karta-container">
    <div left>
        @if(kontrakt){
        <rask-container-block class="kontrakt-container p-0">
            @if (kontrakt.isSkogsvardsKontrakt) {
            <rask-skogsvard-kontrakt [entity]="entity"></rask-skogsvard-kontrakt>
            } @else if (kontrakt.isSkogsvardFPVKontrakt) {
            <rask-skogsvard-fpv-kontrakt [entity]="entity"></rask-skogsvard-fpv-kontrakt>
            } @else if (!kontrakt.isSkogsvardsKontrakt) {
            <rask-virkeskop-kontrakt [entity]="entity"></rask-virkeskop-kontrakt>
            }
        </rask-container-block>
        }
    </div>
    <div right>
        @if (tabVisible$ | async) {
        <rask-vk-karta class="karta-container"
            [entity]="entity">
        </rask-vk-karta>
        }
    </div>
</rask-vertical-collapsable>